import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export const CallFab = () => (
  <a
    href={SITE.phoneHref}
    data-testid="call-fab"
    className="lg:hidden fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-blue-600 text-white shadow-2xl ring-4 ring-blue-600/20 grid place-items-center hover:bg-blue-700 active:scale-95 transition-all"
    aria-label="Call ClearView Pressure Washing"
  >
    <Phone className="h-6 w-6" />
    <span className="absolute inset-0 rounded-full bg-blue-600 animate-ping opacity-20" />
  </a>
);
